module.exports = __webpack_public_path__ + "static/media/ionicons.5d92a3e1.eot";